import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drawer-top" }
const _hoisted_2 = { class: "drawer-content" }

import { watch, onUnmounted } from 'vue';
import Icon from '@/utils/Icon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DrawerRight',
  props: {
  isOpen: Boolean,
  width: {
    type: Number,
    default: 440,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

function closeDrawer() {
  emit('close');
}

watch(() => props.isOpen, (val) => {
  document.body.style.overflow = val ? 'hidden' : '';
});
onUnmounted(() => {
  document.body.style.overflow = '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["drawer-overlay", { open: __props.isOpen }])
  }, [
    _createElementVNode("div", {
      class: "drawer-backdrop",
      onClick: closeDrawer
    }),
    _createElementVNode("div", {
      class: "drawer-panel",
      style: _normalizeStyle({ maxWidth: __props.width + 'px' }),
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "drawer-topLeft"),
        _createElementVNode("div", {
          class: "drawer-close",
          onClick: closeDrawer
        }, [
          _createVNode(Icon, { name: "close" })
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 4)
  ], 2))
}
}

})